// TODO: unused?

const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const AT = require("../vault/ActionTypes");
const {atLeaderboardsRankings} = require("../vault/StateCursors");
const LoadState = require("../vault/util/LoadState");
const AssetsUtil = require("../util/AssetsUtil");
const CopyTable = require("../util/CopyTable");
const NumberUtil = require("../../../shared/Numbers");
const QuadUtil = require("../util/QuadUtil");
const Sounds = require("../util/Sounds");
const Avatar = require("./Avatar");
const LoadGuard = require("./LoadGuard");
const Modal = require("./Modal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const Quad = require("./Quad");
const ScrollArea = require("./ScrollArea");
const StatsIcon = require("./StatsIcon");
const {
	ACADEMY_LEADERBOARDS_WINNER_RANK_CUTOFF,
} = require("../../../shared/Constants");

const styles = require("./styles/LeaderboardsRankings.css");

// Helper for HOC setup
const getPropsFromVault = function(props, vaultState) {
	return {
		rankings:
			atLeaderboardsRankings(vaultState, props).get() || LoadState.loadInit(),
	};
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, getPropsFromVault);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "LeaderboardsModalView",

		propTypes: {
			user: PT.object.isRequired,
			isAcademyUser: PT.bool.isRequired,
			date: PT.string.isRequired,
			metric: PT.string.isRequired,
			usernameFilter: PT.string.isRequired,
			timeWindow: PT.string.isRequired,
			level: PT.string.isRequired,
			campus: PT.string.isRequired,
			// Injected by HOCs
			rankings: PT.object.isRequired,
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				isAvatarModalOpen: false,
				selectedRowIndex: null,
			};
		},

		fetchLeaderboardsRankings: function() {
			const {
				isAcademyUser,
				date,
				metric,
				usernameFilter,
				timeWindow,
				level,
				campus,
			} = this.props;
			this.props.dispatch({
				type: AT.FETCH_LEADERBOARDS_RANKINGS_REQUEST,
				date,
				isAcademyUser,
				usernameFilter,
				metric,
				timeWindow,
				level,
				campus,
			});
		},

		openAvatarModal: function(rowIndex) {
			Sounds.playSound("button-click");
			this.setState({
				isAvatarModalOpen: true,
				selectedRowIndex: rowIndex,
			});
		},

		closeAvatarModal: function() {
			this.setState({
				isAvatarModalOpen: false,
			});
		},

		renderRow: function(rowData, index, userID) {
			const {metric, isAcademyUser, campus} = this.props;
			let metricEl;
			if (isAcademyUser || metric === "totalXp") {
				metricEl = (
					<div className={styles.rightRowContent}>
						<div>{NumberUtil.withCommas(rowData.metric)}</div>
						<StatsIcon
							className={styles.xpIcon}
							type={"xp"}
							style={"trainer"}
						/>
					</div>
				);
			} else if (metric === "totalTrophies") {
				metricEl = (
					<div className={styles.rightRowContent}>
						<div>{rowData.metric}</div>
						<StatsIcon
							className={styles.trophyIcon}
							type={"trophy"}
							style={"trainer"}
						/>
					</div>
				);
			} else if (metric === "newLevelReached") {
				metricEl = (
					<div className={styles.rightRowContent}>
						<div>{`Level ${rowData.metric}`}</div>
					</div>
				);
			}
			let rowClass = index ? styles.borderedRow : styles.row;
			// Highlight the row if it corresponds to the current user.
			const isCurrentUserRow = rowData.userID === userID;
			rowClass += isCurrentUserRow
				? ` ${styles.highlightedRow}`
				: ` ${styles.nonhighlightedRow}`;

			const userIdentifier = isAcademyUser
				? `${rowData.firstName} ${rowData.lastName}${
						isCurrentUserRow ? " (You)" : ""
				  }`
				: `${rowData.username}${isCurrentUserRow ? " (You)" : ""}`;

			let starEl = null;
			if (isAcademyUser) {
				const hasStar =
					campus !== "all" &&
					rowData.rank <= ACADEMY_LEADERBOARDS_WINNER_RANK_CUTOFF;
				starEl = hasStar ? (
					<img
						className={styles.winnerIcon}
						src={AssetsUtil.getStarEarned(3, true)}
					/>
				) : (
					<div className={styles.winnerIcon} />
				);
			}

			return (
				<div
					data-hj-suppress
					className={rowClass}
					key={"row-" + index}
					onClick={() => this.openAvatarModal(index)}
				>
					<div className={styles.leftRowContent}>
						{starEl}
						<div className={styles.rankNumber}>{rowData.rank}.</div>
						<Avatar
							hasSurround={true}
							className={styles.avatar}
							avatar={rowData.avatarData}
						/>
						<div>{userIdentifier}</div>
					</div>
					{metricEl}
				</div>
			);
		},

		renderUserList: function() {
			const {rankings, user} = this.props;
			const rows = _.get(rankings, "rows", []);
			const userID = _.get(user, "userID", 0);
			if (rows.length) {
				return (
					<ScrollArea useWonkyCursor={true}>
						<div className={styles.rowsContainer}>
							{rows.map((r, i) => this.renderRow(r, i, userID))}
						</div>
					</ScrollArea>
				);
			}
			return (
				<div className={styles.noRowsText}>
					{CopyTable.getEmptyLeaderboardsMessage()}
				</div>
			);
		},

		renderAvatarModal: function() {
			const {rankings, isAcademyUser} = this.props;
			const {selectedRowIndex} = this.state;
			const selectedUserData = _.get(rankings, ["rows", selectedRowIndex], {});
			const nameQuad = QuadUtil.getLeaderboardsSet().avatarModalUsername;
			const userIdentifier = isAcademyUser
				? `${selectedUserData.firstName} ${selectedUserData.lastName}`
				: selectedUserData.username;
			return (
				<Modal
					portalContainer={PORTAL_CONTAINERS.TRAINER_MESSAGE}
					closeOnBackdropClick={true}
					closeOnEsc={true}
					hasCloseButton={true}
					levelType="aboveAll"
					backdropClass={styles.modalAvatarBackdrop}
					modalClass={styles.modalAvatarMain}
					closeClass={styles.modalAvatarCloseIcon}
					onClose={this.closeAvatarModal}
				>
					<Avatar
						hasSurround={true}
						className={styles.modalAvatarImage}
						avatar={selectedUserData.avatarData}
					/>
					<div className={styles.modalAvatarUsername}>
						<div className={styles.modalAvatarUsernameBG}>
							<Quad
								quad={nameQuad}
								backgroundClass={styles.modalAvatarUsernameQuad}
								shadowOffset={3}
								shadowOpacity={0.2}
							/>
						</div>
						{userIdentifier}
					</div>
				</Modal>
			);
		},

		render: function() {
			const {
				isAcademyUser,
				rankings,
				date,
				metric,
				usernameFilter,
				timeWindow,
				level,
				campus,
			} = this.props;
			const {isAvatarModalOpen} = this.state;
			const loadIdentifier = isAcademyUser
				? `leaderboardRankings ${date} ${metric} ${level} ${campus}`
				: `leaderboardRankings ${date} ${metric} ${usernameFilter} ${timeWindow}`;
			const listEl = (
				<LoadGuard
					identifier={loadIdentifier}
					status={rankings}
					requestLoad={this.fetchLeaderboardsRankings}
					loadingView="logo"
					logoColorType="blue"
					loadingViewClass={styles.loadIcon}
					errorView="refresh"
					renderLoaded={this.renderUserList}
				/>
			);
			let avatarModalEl = null;
			if (isAvatarModalOpen) {
				avatarModalEl = this.renderAvatarModal();
			}
			return (
				<div className={styles.main}>
					{listEl}
					{avatarModalEl}
				</div>
			);
		},
	})
);
